import React from 'react';

import { FeatureErrorBoundary, ScreenErrorFallback } from '../../core-components/theme/components/FeatureErrorBoundary';

export const guardedRoute = (
  feature: string,
  node: React.ReactNode,
  resetKeys?: readonly unknown[],
): React.ReactElement => (
  <FeatureErrorBoundary feature={feature} resetKeys={resetKeys} fallback={(reset) => <ScreenErrorFallback onRetry={reset} />}>
    {node}
  </FeatureErrorBoundary>
);
